const supplierRegister = {
  state: {
    check_page:0
  },
  mutations: {
    SET_CHECK_PAGE: (state, step) => {
      state.check_page = Number(step);
    }
  },
  actions: {
    // 更改当前步骤
    changeCheckPage ({ commit, dispatch }, step) {
      return new Promise(resolve => {
        commit('SET_CHECK_PAGE', step)
        sessionStorage.setItem('SET_CHECK_PAGE', step)
      })
    }
  }
}

export default supplierRegister
